import ProposalMetaInformation from './ProposalMetaInformation';

export default ProposalMetaInformation;
